// extracted by mini-css-extract-plugin
export var secondaryTitle = "styles-module--secondaryTitle--f257f";
export var title = "styles-module--title--5282b";